import React, { createContext, useReducer } from 'react';
import TwoCards from '../../../../../components/Card/TwoCards';
import { initialState, reducer, actions } from './reducer';
import SecondaryContent from './SecondaryContent';
import CommissionContent from './CommissionContent';
import useTitle from 'hooks/useTitle';

export const store = createContext(null);
const { Provider } = store;

const Commission = () => {
  useTitle('ضرایب مالی')
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <Provider value={{ state, dispatch, actions }}>
      <TwoCards
        title="ضرایب مالی"
        category="ضرایب مالی دخیل در کمیسیون، در بخش درصد بایستی برای هر دو حالت کامل و پلیس راهی وارد شود"
        secondaryTitle={
          state.commission && state.commission._id
            ? 'ویرایش ضریب مالی'
            : 'افزودن ضریب مالی'
        }
        secondaryContent={<SecondaryContent />}
      >
        <CommissionContent />
      </TwoCards>
    </Provider>
  );
};

export default React.memo(Commission);
